import { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import { RecoilRoot } from "recoil";

import routes from "@configs/routes";
import ThemeToken from "@configs/theme";

import "./public-path";
import "./index.less";
import useUpdateAwsToken from "./hooks/useUpdateAwsToken";

function App() {
  const { updateAwsToken, cancelUpdateAwsToken } = useUpdateAwsToken();

  useEffect(() => {
    document.onreadystatechange = function () {
      if (document.readyState !== "complete") return;
      updateAwsToken();
    };

    return () => {
      document.onreadystatechange = null;
      cancelUpdateAwsToken();
    };
  }, []);

  return (
    <RecoilRoot>
      <RouterProvider router={createBrowserRouter(routes, {})} />
    </RecoilRoot>
  );
}

let root: any;
const render = (props: any) => {
  const { container } = props;
  root = ReactDOM.createRoot(
    container
      ? container.querySelector("#root")
      : (document.getElementById("root") as HTMLElement)
  );

  root.render(
    <ConfigProvider
      locale={enUS}
      theme={{
        token: ThemeToken,
      }}
    >
      <App />
    </ConfigProvider>
  );
};

if (!(window as any).__POWERED_BY_QIANKUN__) {
  render({});
}

export async function bootstrap() {
  console.log("[react18] react app bootstraped");
}

export async function mount(props: any) {
  console.log("[react18] props from main framework", props);
  render(props);
}

export async function unmount() {
  root?.unmount();
}

if ((window as any).__POWERED_BY_QIANKUN__) {
  (window as any).qiankunLifecycle = {
    bootstrap,
    mount,
    unmount,
  };
}
